// extracted by mini-css-extract-plugin
module.exports = {"page-title":"Trending_page-title__2MTMo","error":"Trending_error__1SAAM","loading":"Trending_loading__2YkqN","spin":"Trending_spin__1lo-p","trending":"Trending_trending__PI1JW"};